import React, { ButtonHTMLAttributes } from 'react';
import { VoxelAlertSeverity } from '../Alert/VoxelAlert';
import VoxelText from '../Text/VoxelText';
import VoxelTooltipShort from '../Tooltip/VoxelTooltipShort';

export interface VoxelChipProps
  extends Pick<
    ButtonHTMLAttributes<HTMLButtonElement>,
    'onClick' | 'onMouseDown' | 'onMouseUp' | 'type' | 'disabled'
  > {
  title: string | React.ReactNode;
  color?: VoxelAlertSeverity;
  tooltip?: string;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
}

const VoxelTrendChip: React.FC<VoxelChipProps> = ({
  title,
  disabled,
  tooltip,
  color = 'neutral',
  size = 'md',
}) => {
  // ---- COLOR ----
  let textColor = '';
  let bgColor = '';

  if (color === 'neutral') {
    bgColor = 'bg-voxel-gray-100';
    textColor = 'text-voxel-gray-700';
  }
  if (color === 'error') {
    bgColor = 'bg-error-100';
    textColor = 'text-error-700';
  }
  if (color === 'warning') {
    bgColor = 'bg-warning-500/20';
    textColor = 'text-warning-800';
  }
  if (color === 'success') {
    bgColor = 'bg-success-600/20';
    textColor = 'text-success-900';
  }
  if (color === 'info') {
    bgColor = 'bg-info-600/20';
    textColor = 'text-info-900';
  }

  let padding = `
      ${size === 'xxs' ? 'px-1 py-[2px] gap-0.5' : ''}        
      ${size === 'xs' ? 'px-1.5 py-[3px] gap-0.5' : ''}    
      ${size === 'sm' ? 'px-2 py-1 gap-1.5' : ''}
      ${size === 'md' ? 'px-2.5 gap-1.5' : ''}
      ${size === 'md' && !close ? 'py-[5.5px]' : ''}
    `;

  let fontSize = `
  ${size === 'xxs' ? 'text-[11px]' : ''}
  ${size === 'xs' ? 'text-[11px]' : ''}
  ${size === 'sm' ? 'text-xs' : ''}
  ${size === 'md' ? 'text-xs' : ''}
  `;

  return (
    <VoxelTooltipShort message={tooltip} disabled={!tooltip || disabled}>
      <div
        className={`
                select-none cursor-default
                inline-block
                rounded
                ${padding}
                ${bgColor} 
                whitespace-nowrap ${fontSize} leading-none ${textColor} 
            `}
      >
        <VoxelText variant="bread-medium" className={`pb-[1px]`}>
          {title}
        </VoxelText>
      </div>
    </VoxelTooltipShort>
  );
};

export default VoxelTrendChip;
